export interface Preferences {
  autoAdvance: boolean;
  readingFont: "clear" | "classic";
  textScale: 1 | 1.25 | 1.5 | 2;
}
export const PREFERENCES_KEY = "lunyu-reading-preferences-v1";
export function loadPreferences(): Preferences {
  let raw: Partial<Preferences> = {};
  try { raw = JSON.parse(localStorage.getItem(PREFERENCES_KEY) || "{}"); } catch { /* use defaults */ }
  return {
    autoAdvance: raw?.autoAdvance === true,
    readingFont: raw?.readingFont === "classic" ? "classic" : "clear",
    textScale: [1, 1.25, 1.5, 2].includes(raw?.textScale ?? 0) ? raw.textScale! : 1,
  };
}
export function savePreferences(value: Preferences): void {
  document.documentElement.dataset.readingFont = value.readingFont;
  document.documentElement.dataset.readingScale = String(value.textScale);
  document.documentElement.style.setProperty("--reading-scale", String(value.textScale));
  try { localStorage.setItem(PREFERENCES_KEY, JSON.stringify(value)); } catch { /* stays in memory */ }
}
